import { ProductCardType } from "./productCardType"

// Mock data for cards
export const homeCardsData: { id: number, type: ProductCardType }[] = [
    {
        id: 1,
        type: ProductCardType.socker,
    },
    {
        id: 2,
        type: ProductCardType.basketball,
    },
    {
        id: 3,
        type: ProductCardType.casino,
    },
    {
        id: 4,
        type: ProductCardType.playstation,
    },
    {
        id: 5,
        type: ProductCardType.xbox,
    },
    {
        id: 6,
        type: ProductCardType.steam,
    }
]